//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      form: {
        loginName: "",
        fullName: "",
        mobile: "",
        cusId: "",
        roleIds: [],
      },
      rules: {
        loginName: {
          required: true,
          message: "请输入OA账号",
          trigger: "blur",
        },
        roleIds: {
          required: true,
          message: "请选择角色权限",
          trigger: "change",
        },
      },
      codeShow: true,
      count: "",
      timer: null,
      roles: [],
      authData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      authLoading: false,
      oaInfo: "", // OA账号信息
    };
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    getRoleList() {
      let params = {
        roleType: 2,
      };
      this.$http.account.getAllSRoleList(params).then((res) => {
        this.roles = res.data;
      });
    },
    /**
     * @descripttion: 提交信息
     * @Author: juanjuanhui
     * @Date: 2021-11-17 10:44:50
     * @param {*} formName
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = { ...this.form };
          this.$http.account.addManageAccount(params).then((res) => {
            if (res.status == 1) {
              this.$message({
                type: "success",
                message: "新增账号成功",
                duration: 2000,
              });
              this.$router.go(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 根据oa登录账号查账号信息
     * @Author: yangsibo
     * @Date: 2022-05-26 16:49:25
     * @return {*}
     */
    async getOaInfo() {
      try {
        let loginName = this.form.loginName;
        let { status, data } = await this.$http.account.getOaInfo({
          loginName,
        });
        if (status == "1" && data) {
          this.form.cusId = data.admin.id;
          this.form.fullName = data.admin.fullname;
          this.form.mobile = data.admin.mobile;
        }
        if (status == "0") {
          this.form.loginName = "";
        }
      } catch (error) {
        this.form.loginName = "";
      }
    },
    /**
     * @descripttion: 选择角色
     * @Author: juanjuanhui
     * @Date: 2022-02-17 17:00:14
     * @param {*} data 已选项
     */
    handleChangeRole(data) {
      this.authLoading = true;
      this.authData = [];
      if (data && data.length > 0) {
        let params = {
          roleIdList: data,
        };
        this.$http.common
          .selectOwnSMenuTree(params)
          .then((res) => {
            this.authData = res.data;
            this.authLoading = false;
          })
          .catch(() => {
            this.authLoading = false;
          });
      }
    },
  },
};
